import { fromJS } from 'immutable';
import { createReducer } from 'redux-create-reducer';
import * as actions from './actions';
import * as analytics from '../../utils/analytics';

export const initialState = fromJS({
  loading: false,
  customers: {},
  customerData: {}
});

export default createReducer(initialState, {
  [actions.FETCH_CUSTOMERBYID]: state => state.set('loading', true),
  [actions.FETCH_CUSTOMERBYID_FAILED]: (state, action) =>
    state.set('loading', false).set('error', action.error),
  [actions.FETCH_CUSTOMERBYID_SUCCESS]: (state, action) => {
    analytics.updateCustomer(action.payload);
    return state.set('loading', false).set('customerData', fromJS(action.payload));
  }
});
